/*eslint-disable*/
import { Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";
const applicationId = process.env.REACT_APP_CLIENT_ID;
const tenantId = process.env.REACT_APP_TENANT_ID;

const authority = `https://login.microsoftonline.com/${tenantId}`;

// let RedirectUri = 'http://localhost:3000/auth/callback'
const RedirectUri = process.env.REACT_APP_REDIRECT_URI;

// console.log(RedirectUri, "RedirectUri");

export const MSAL_CONFIG: Configuration = {
  auth: {
    clientId: applicationId || "",
    authority: authority || "",
    redirectUri: RedirectUri,
    postLogoutRedirectUri: `${RedirectUri}`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  // scopes: ["User.Read"],
  scopes: [`${applicationId}/.default` , "offline_access"],
  prompt: "select_account",
};

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(MSAL_CONFIG);